module.exports = __webpack_public_path__ + "img/dv_line1.b3242c5e.png";